import { merge } from 'lodash';
import Resource from 'Resources/Resource';
import type UserModel from 'App/resources/Model/User';
import AppService from 'App/legacy/AppService';
import EventBus from 'App/services/EventBus';

class User extends Resource {
	constructor() {
		super('users', null, { notificationTitle: 'default.user' });
	}

	async update(data: Partial<UserModel>) {
		const res = await this.save(data, { _url: `master/users` });

		var self = AppService.getSelf();
		if (data.id === self.id) {
			EventBus.broadcast('self.updated', merge(self, res.data));
		} else {
			const userMap = AppService.getUserMap();
			const nextUserMap = Object.entries(userMap).reduce<typeof userMap>((result, [type, users]) => {
				result[type] = users.map(user => {
					if (user.id === data.id) {
						return merge(user, res.data);
					} else {
						return user;
					}
				});
				return result;
			}, {});

			AppService.setUserMap(nextUserMap);
			await setTimeout(Promise.resolve, 0);
		}
	}
}

const resource = new User();

export default resource;
